module.exports = __webpack_public_path__ + "static/media/animoca.78397604.png";